export const MULTIPLAYER_CONFIG = Object.freeze({
  protocolVersion: 3,
  contentBuildId: "vilnius-m10-v3",
  minimumPlayers: 1,
  maximumPlayers: 8,
  roomNameMaximumCharacters: 48,
  displayNameMaximumCharacters: 24,
  passwordMaximumCharacters: 72,
  chatMaximumCharacters: 200,
  chatHistoryLimit: 50,
  chatHistoryOnJoin: 20,
  semanticEventHistoryLimit: 64,
  chatMessagesPerWindow: 5,
  chatRateWindowMilliseconds: 10_000,
  inputBatchMaximum: 12,
  inputSilenceNeutralMilliseconds: 500,
  connectionHeartbeatTimeoutMilliseconds: 15_000,
  websocketFrameMaximumBytes: 24 * 1_024,
  serverTickRateHz: 60,
  // Local prediction runs at 60 Hz; remote entities interpolate a compact
  // authoritative feed over this interval instead of rendering packet steps.
  snapshotRateHz: 8,
  remoteInterpolationMilliseconds: 150,
  // Presentation-only user tuning: preserve locally predicted height when an
  // authoritative replay corrects it, then settle onto the corrected path.
  // Simulation position, collision, speed and acceleration stay authoritative.
  localVerticalReconciliationResponsePerSecond: 8,
  localVerticalReconciliationMaximumSmoothedDistanceMeters: 1,
  dayLengthSeconds: 24 * 60,
  keyframeIntervalMilliseconds: 15_000,
  reconnectGraceMilliseconds: 20_000,
  ticketLifetimeMilliseconds: 30_000,
  emptyRoomLifetimeMilliseconds: 30 * 60_000,
  roomListLimit: 100,
  // Cloudflare Workers currently caps Web Crypto PBKDF2 at 100,000 rounds.
  passwordIterations: 100_000,
  passwordSaltBytes: 16,
  passwordHashBytes: 32,
  spawn: Object.freeze({ x: 456.129, y: 0, z: 390.24 }),
});

export const MULTIPLAYER_API_BASE = "/api/multiplayer";

export const MULTIPLAYER_SOLO_SESSION_KEY = "vilnius.multiplayer.solo-session";
